import {APIError} from '../core/errors';
import {employeeSigninRequest, employeeSigninResponse} from '../lib/types';
import httpClient from '../services/http.service';
import {BASE_URL, DEFAULT_HEADERS} from './api-constants';

const _api_base_url = `${BASE_URL}/employee/login`;
//  'https://run.mocky.io/v3/fe53d798-9cb7-42c7-90ba-1765f6f50bd4';
//'http://14.142.50.123:7001/BuddyLMREnrolementWS/LSBEnrolement/LSBuddyEnrolDetails';
//TODO: - write the API calls here
// test user fetch.
// TODO: remove later
export const employeesigninApiCall = async (
  parameters: employeeSigninRequest,
): Promise<employeeSigninResponse> => {
  //todo
  // dob has to be non mandatory

  try {
    const response = await httpClient.post(`${_api_base_url}`, parameters, {
      headers: {
        ...DEFAULT_HEADERS,
      },
    });
    return response.data;
  } catch (error) {
    console.error(error);
    throw new APIError(error);
  }
};
